import React from "react";
import RequirementSection from "../components/RequirementSection";

const SectionA = () => <RequirementSection section="A" />;

export default SectionA;